import { Icon, Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumbs = (props) => {
  const {
    data,
    separator = (
      <Icon baseClassName="fa-solid fa-angle-right breadcrumbs-item-right-icon" />
    ),
  } = props || {};

  return (
    <MuiBreadcrumbs separator={separator} aria-label="breadcrumb">
      {data?.map((item, index) =>
        item?.href ? (
          <Link key={`breadcrumb_${index}`} to={item.href}>
            {item.name}
          </Link>
        ) : (
          <Typography key={`breadcrumb_${index}`} color="text.primary">
            {item.name}
          </Typography>
        )
      )}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
